import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { TenantService } from '@core/auth2/services/tenant.service';
import { inject } from '@angular/core';

export abstract class TenantBaseService {
  protected readonly tenantService: TenantService;

  get tenantBaseUrl$(): Observable<string> {
    return this.tenantService.tenantId$.pipe(
      map(tenantId => this.baseUrl + `/o/${tenantId}`),
      take(1),
    );
  }

  protected constructor(protected baseUrl: string) {
    this.tenantService = inject(TenantService);
  }
}
